// Maps the internal `selectedKey` values used by the Dashboard sidebar to
// real, shareable/refreshable URL paths (and back again).
export const ROUTE_MAP = {
  Dashboard: "/dashboard",
  "Dashboard/User": "/dashboard/user",
  AI_Article: "/ai-article",
  Medicines: "/medicines",
  AssignTarget: "/assign-target-crm",
  CommissionRates: "/commission-rates",
  Crm_System: "/crm-system",
  Users: "/users",
  Customers: "/customers",
  CommodityRates: "/commodity-rates",
  RateCorrection: "/rate-correction",
  DailyRateBaseline: "/daily-rate-baseline",
  MandiRates: "/mandi-rates",
  MandiGurus: "/mandi-gurus",
  Videos: "/videos",
  Posts: "/posts",
  News_Articles: "/news-articles",
  Ads: "/ads",
  FeedBack: "/feedback",
  Notification: "/notification",
  "Schedule-Notification": "/schedule-notification",
  Franchase: "/franchise",
  Tags: "/tags",
  Tips: "/tips",
  News: "/news",
  FarmersWeek: "/farmers-of-the-week",
  PhoneDirectory: "/phone-directory",
  Drafts: "/news-articles/draft",
};

// selectedKey (+ optional subkey, e.g. the drill-down tab on the
// Dashboard/User screen) -> a unique url path.
export const keyToPath = (key, subkey) => {
  let base;
  if (!key) {
    base = ROUTE_MAP.Dashboard;
  } else if (ROUTE_MAP[key]) {
    base = ROUTE_MAP[key];
  } else {
    const slug = key
      .replace(/_/g, "-")
      .replace(/([a-z0-9])([A-Z])/g, "$1-$2")
      .toLowerCase();
    base = "/" + slug;
  }
  if (subkey) {
    base += "/" + encodeURIComponent(subkey);
  }
  return base;
};

// url path -> { key, subkey } (key is null if unrecognized)
export const pathToKey = (pathname) => {
  if (!pathname || pathname === "/") return { key: null, subkey: "" };
  const clean = pathname.replace(/\/+$/, "");
  const segments = clean.split("/").filter(Boolean);

  // Match the longest known base path first so "/dashboard/user/..."
  // resolves to "Dashboard/User" rather than just "Dashboard".
  for (let len = segments.length; len >= 1; len--) {
    const base = "/" + segments.slice(0, len).join("/");
    const match = Object.keys(ROUTE_MAP).find((k) => ROUTE_MAP[k] === base);
    if (match) {
      const rest = segments.slice(len);
      const subkey = rest.length ? decodeURIComponent(rest.join("/")) : "";
      return { key: match, subkey };
    }
  }
  return { key: null, subkey: "" };
};
